import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { WorkflowRuleType } from '@/modules/workflow/enums/WorkflowRuleType';
import { JurisdictionSelectConfig } from '@/modules/predefined/models/JurisdictionSelectConfig';
import { EnumFormSelectConfig } from '@/modules/core/form/models/EnumFormSelectConfig';
import { EstateType } from '@/modules/estate/enums/EstateType';
import Lang from '@/modules/core/app/services/Lang';
import { BillingPlanSelectConfig } from '@/modules/billing/models/BillingPlanSelectConfig';
import { EstatePaymentStatus } from '@/modules/estate/constants/EstatePaymentStatus';

export class WorkflowRuleSelect extends BaseModel {
  type?: string;
  selection: BaseModel[];

  constructor(model: Partial<WorkflowRuleSelect> = {}) {
    super();

    this.type = model.type;
    this.selection = model.selection ?? [];
  }

  getRuleSelectConfig(): FormSelectConfig | undefined {
    switch (this.type) {
      case WorkflowRuleType.JURISDICTION.key:
        return this.getJurisdictionRuleSelectConfig();
      case WorkflowRuleType.PRODUCT.key:
        return this.getProductRuleSelectConfig();
      case WorkflowRuleType.BILLING_PLAN.key:
        return this.getBillingPlanRuleSelectConfig();
      case WorkflowRuleType.PAYMENT_STATUS.key:
        return this.getPaymentStatusRuleSelectConfig();
      default:
        return undefined;
    }
  }

  private getJurisdictionRuleSelectConfig(): JurisdictionSelectConfig {
    return new JurisdictionSelectConfig({
      placeholder: Lang.t('estate.jurisdiction'),
      multiple: true,
      allowEmpty: true,
      groupSelect: true,
      limit: 4,
      closeOnSelect: false,
      trackBy: 'id'
    });
  }

  private getProductRuleSelectConfig(): EnumFormSelectConfig {
    return new EnumFormSelectConfig(EstateType, {
      placeholder: Lang.t('asset.product'),
      hiddenValues: [EstateType.CLEAR_WILL.key],
      multiple: true,
      allowEmpty: true,
      label: 'filterName',
      trackBy: 'key'
    });
  }

  private getBillingPlanRuleSelectConfig(): BillingPlanSelectConfig {
    return new BillingPlanSelectConfig({ multiple: true, allowEmpty: true, trackBy: 'id' });
  }

  private getPaymentStatusRuleSelectConfig(): EnumFormSelectConfig {
    return new EnumFormSelectConfig(EstatePaymentStatus, {
      placeholder: Lang.t('estate.payment-status'),
      hiddenValues: [EstatePaymentStatus.UNPAID.key],
      multiple: true,
      allowEmpty: true,
      label: 'value',
      trackBy: 'key'
    });
  }
}
